export default __webpack_public_path__ + "static/media/kvistholt-photography-191153-unsplash.0206c05e.jpg";